import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    "ContentDiv": styled.div`
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 90px;
        background-color: ${({ theme }) => theme.color.white};
        padding: 80px 60px;
        border-radius: 12px;
    `,
    "LogoImg": styled.img`
        width: 200px;    
    `,
    "FormDiv": styled.div`
        width: 456px;
        display: flex;
        flex-direction: column;
        gap: 20px;

        & > input {
            border: 1px solid ${({ theme }) => theme.color.grey2};
            border-radius: 8px;
            ${({ theme }) => theme.font.small};
            padding: 12px 20px;
        }
    `,
    "ButtonDiv": styled.div`
        display: flex;
        gap: 8px;
    `,
}